<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="page-head d-flex flex-wrap align-center justify-space-between">
      <div>
        <h1 class="page-head__title">
          {{ schoolName ? schoolName : "Students" }}
        </h1>
        <Breadcrumbs
          :items="[
            { text: 'All Schools', disabled: false, href: '/admin/schools/all' },
            { text: 'Students', disabled: true }
          ]"
        />
      </div>
      <v-btn
        :to="{
          name: 'admin.schools.students.add',
          params: { id: $route.params.id },
          query: { name: $route.query.name }
        }"
        color="primary"
        depressed
        class="text-none add-btn"
      >
        <v-icon small left>mdi-plus</v-icon>
        Add New Student
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="allSchools"
      :loading="pageLoading"
      :server-items-length="paginate.total"
      :options.sync="options"
      class="data-table"
      loading-text="Loading… Please wait"
      :footer-props="{ itemsPerPageOptions: [30, 40, 50] }"
    >
      <template #item.idNumber="{ item }">
        <span class="pill pill--muted">{{ item.idNumber }}</span>
      </template>
      <template #item.name="{ item }">
        <span class="cell-strong text-capitalize">{{ item.name }}</span>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{
                name: 'admin.schools.students.add',
                query: {
                  id: item._id,
                  action: 'edit',
                  name: $route.query.name ? $route.query.name : schoolName
                }
              }"
              v-on="on"
              icon
              small
              class="cell-action"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Edit student details</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :loading="isLoading"
              @click="
                $store.dispatch('schools/deleteStudent', {
                  id: item._id,
                  schoolId: $route.params.id
                })
              "
              icon
              small
              class="cell-action cell-action--danger"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Delete student details</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>

<script>
//import { debounce } from "lodash";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
export default {
  name: "AllStaffs",
  data() {
    return {
      options: {},
      search: "",
      searchTerm: null,
      schoolName: ""
    };
  },
  components: {
    SnackBar: loadComponent(`component/SnackBar`),
    //PageTitle: loadComponent(`component/PageTitle`),
    Breadcrumbs: loadComponent(`component/Breadcrumbs`)
  },

  computed: {
    ...mapGetters({
      allSchools: "schools/getAllStudents",
      pageLoading: "getIsPageLoading",
      isLoading: "getIsLoading",
      paginate: "schools/getPagination"
    }),
    form() {
      return {
        name: this.name,
        phone: this.phone,
        accountNumber: this.accountNumber
      };
    },
    staffList() {
      return this.allStaff.filter(searchTerm => {
        return (
          searchTerm.name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },

    headers() {
      return [
        {
          text: "ID Number",
          value: "idNumber",
          filterable: true,
          sortable: false
        },
        {
          text: "Name",
          value: "name",
          filterable: true,
          sortable: false
        },
        {
          text: "Actions",
          value: "actions"
        }
      ];
    }
  },
  filters: {
    status(value) {
      return !value ? "Active" : "Inactive";
    },
    firstLetterFunction(value) {
      return value.charAt(0).toUpperCase();
    }
  },
  mixins: [SnackBarMixins],
  watch: {
    options: {
      handler(value) {
        const { itemsPerPage, page } = value;
        const query = `?page=${page}&size=${itemsPerPage}`;
        this.$store.dispatch("schools/listAllStudents", {
          id: this.$route.params.id,
          query
        });
      },
      deep: true
    }
  },
  methods: {},
  created() {
    this.schoolName = this.$route.query.name ?? "";
    const query = `?page=1&size=30`;
    this.$store.dispatch("schools/listAllStudents", {
      id: this.$route.params.id,
      query
    });
  }
};
</script>

<style scoped>
.add-btn {
  border-radius: var(--radius) !important;
  height: 40px !important;
  font-weight: 600;
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.cell-action {
  color: var(--muted-foreground) !important;
  margin: 0 2px;
}
.cell-action--danger:hover {
  color: var(--status-failed) !important;
}
</style>
